<template>
  <el-drawer
    :visible.sync="visible"
    :modal="false"
    :withHeader="false"
    :size="isMobile ? '100%' : 300"
    custom-class="quickSwitchWrap"
    :style="isMobile ? { height: '101%', 'z-index': 999 } : { height: `${drawerHeight}px !important`, top: `${drawerTop}px !important` }"
  >
    <div class="titleOperWrap">
      <div class="close" v-if="isMobile" @click="closeMe"></div>
      <div class="title" :title="shelfName">{{ isSwitch ? '切换刊物' : shelfName | filterShelfName }}</div>
      <div class="oper">
        <span v-if="curMode === modeMap.thumb" @click="changeMode(modeMap.list)" class="toList" title="查看列表"></span>
        <span v-else @click="changeMode(modeMap.thumb)" class="toThumb" title="查看封面"></span>
        <!-- 若有allLibAlbums，则是从图书馆里打开，否则不展示“切换刊物” -->
        <template v-if="allLibAlbums">
          <span v-if="isSwitch" class="toSwitchBack" @click="changeSwitch(false)" title="返回"></span>
          <span v-else class="toSwitch" @click="changeSwitch(true)" title="切换刊物"></span>
        </template>
      </div>
    </div>
    <div v-show="!isSwitch && curYear !== 'epaper'" class="yearWrap">
      <el-select v-if="isMobile" v-model="curYear" placeholder="请选择年份" :style="{ width: '40vw' }" popper-class="quickSwitchSelect">
        <el-option v-for="year in yearArr" :key="year" :value="year"> </el-option>
      </el-select>
      <el-tabs v-else v-model="curYear" type="card" @tab-click="chooseYear" :class="yearArr.length <= 4 && 'year-center'">
        <el-tab-pane v-for="year in yearArr" :key="year" :name="year" :label="year"></el-tab-pane>
      </el-tabs>
    </div>
    <el-scrollbar>
      <!-- 减去 titleOperWrap高度44 和 yearWrap高度26, isSwitch时只有44 -->
      <div :class="['contentWrap', curMode === modeMap.list && 'list', isMobile && 'mobile']" :style="{ height: `${autoScrollHeight}px` }">
        <div :class="['book', curChoose === book.title && 'active']" v-for="(book, index) in isSwitch ? magaArr : bookArr" :key="index" @click="chooseBook(book)">
          <div v-show="curMode === modeMap.thumb" class="cover">
            <img :src="book.coverUrl" alt="cover" />
          </div>
          <div class="name" :title="book.title">{{ book.title }}</div>
        </div>
      </div>
    </el-scrollbar>
  </el-drawer>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: [
    'shelfName', // 当前专辑名称
    'allBooksRaw', // 当前专辑下所有书籍，按年份划分,考虑报纸专辑情形，对原始数据做一次处理
    'allLibAlbums' // 当前图书馆下所有专辑
  ],
  data() {
    return {
      isSwitch: false, // 是否在切换报刊级别
      modeMap: { thumb: 'THUMB', list: 'LIST' }, // 模式的字典
      curMode: 'THUMB', // 当前模式（缩略图/列表）
      visible: false, // 抽屉是否可见
      drawerHeight: 0, // 抽屉高度
      drawerTop: 0, // 抽屉top位置
      curYear: null, // 当前所属的年份
      curBook: null, // 当前所属的书籍
      curMaga: null, // 当前所属的刊物
      curMagaId: null, // 选中刊物的id
      curChoose: null // 当前选中的（书籍/刊物）
    }
  },
  filters: {
    // 处理专辑名过长
    filterShelfName(val) {
      return val.length > 10 ? `${val.slice(0, 10)}...` : val
    }
  },
  computed: {
    ...mapState('book', ['isMobile']),
    allBooks() {
      // 若allBooks为数组，则为报纸，处理成对象形式
      const { allBooksRaw } = this
      return Array.isArray(allBooksRaw) ? { epaper: allBooksRaw } : allBooksRaw
    },
    // 年份数组
    yearArr() {
      return this.allBooks ? Object.keys(this.allBooks).sort((a, b) => `${b - a}`) : []
    },
    // 书籍数组
    bookArr() {
      return this.allBooks ? this.allBooks[this.curYear] : []
    },
    // 刊物数组
    magaArr() {
      return this.allLibAlbums
        ? this.allLibAlbums.map((item) => {
            return {
              coverUrl: item.coverUrl,
              title: item.name,
              id: item.id.replace('album', '')
            }
          })
        : []
    },
    // 自动调整滚动条内容高度
    autoScrollHeight() {
      return this.drawerHeight - (this.isSwitch ? 44 : 70)
    }
  },
  methods: {
    // 调整抽屉高度
    setHeight() {
      if (this.isMobile) {
        this.drawerHeight = window.innerHeight
      } else {
        const tgt = document.getElementsByClassName('book-wrapper')[0]
        const tgt1 = document.getElementsByClassName('book-title')[0]
        if (tgt && tgt1) {
          this.drawerHeight = tgt.clientHeight - 80 // 减去header高度40，footer高度40
          this.drawerTop = tgt1.getBoundingClientRect().bottom
        }
      }
      // 触发滚动条样式自适应
      this.drawerHeight = this.drawerHeight - 1
      setTimeout(() => {
        this.drawerHeight = this.drawerHeight + 1
      }, 0)
    },
    // 切换年份
    chooseYear() {
      this.setHeight()
    },
    // 切换书籍/刊物按钮
    chooseBook(book) {
      this.curChoose = book.title
      // 若为切换书刊
      if (this.isSwitch) {
        this.$emit('changeAlbumId', book.id)
        this.curMaga = book.title // 当前选中刊物
        this.curMagaId = book.id
        this.changeSwitch(false)
      } else {
        // 若为切换书籍
        const { id, shelfId } = this.$route.query
        // 若选中的不是当前书籍
        if (book.id !== +id) {
          this.$router.push({
            path: '/content',
            query: {
              ...this.$route.query,
              id: book.id,
              // curMagaId若为空，则代表还未切换过专辑，则取当前专辑
              shelfId: this.curMagaId || shelfId
            }
          })
          location.reload()
        }
      }
    },
    // 切换缩略图/列表模式
    changeMode(mode) {
      this.curMode = mode
      this.setHeight()
    },
    // 切换刊物模式开关
    changeSwitch(isSwitch) {
      this.isSwitch = isSwitch
      // 切换书籍 -> 切换刊物
      if (isSwitch) {
        this.curChoose = this.curMaga
      } else {
        // 切换刊物 -> 切换书籍
        this.curChoose = this.curBook
      }
      this.setHeight()
    },
    // 关闭抽屉
    closeMe() {
      this.visible = false
    }
  },
  created() {
    window.addEventListener('resize', this.setHeight)
  },
  mounted() {
    this.setHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.setHeight)
  },
  watch: {
    // 自动选中年份、期刊
    allBooks(newV) {
      // 若未找到，则选中第一个年份，书籍暂不自动选第一个
      this.curYear = this.yearArr[0]
      // this.curBook = this.bookArr[0].title
      // this.curChoose = this.bookArr[0].title // 默认选中书籍
      const curId = this.$route.query.id
      Object.keys(newV || {}).forEach((year) => {
        const element = newV[year]
        const target = element.find((item) => item.id === +curId)
        if (target) {
          this.curBook = target.title
          this.curYear = year
          this.curChoose = target.title // 默认选中书籍
          return false
        }
      })
    },
    // 自动选中当前刊物
    allLibAlbums(newV) {
      const curAlbumId = this.$route.query.shelfId
      const targetTmp = (newV || []).find((item) => {
        return item.id.replace('album', '') === curAlbumId
      })
      if (targetTmp) {
        this.curMaga = targetTmp.name
      }
      this.setHeight()
    }
  }
}
</script>
<style lang="scss">
@mixin icon {
  width: 20px;
  height: 20px;
  background-size: 20px;
}
.quickSwitchWrap {
  background: #000 !important;
  .titleOperWrap {
    margin: 12px 24px;
    display: flex;
    justify-content: space-between;
    .close {
      @include icon;
      background-image: url('../../../assets/imgs/close-quick-switch.png');
    }
    .title {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
      line-height: 20px;
    }
    .oper {
      height: 20px;
      span {
        @include icon;
        display: inline-block;
        cursor: pointer;
        &:not(:last-child) {
          margin-right: 13px;
        }
        &.toList {
          background-image: url('../../../assets/imgs/to-list.png');
        }
        &.toThumb {
          background-image: url('../../../assets/imgs/to-thumb.png');
        }
        &.toSwitch {
          background-image: url('../../../assets/imgs/to-switch.png');
        }
        &.toSwitchBack {
          background-image: url('../../../assets/imgs/to-switch-back.png');
        }
      }
    }
  }
  .yearWrap {
    padding: 0 24px 6px;
    text-align: center;
    .el-tabs {
      .el-tabs__header {
        border: 0;
        margin: 0;
        .el-tabs__nav-prev,
        .el-tabs__nav-next {
          line-height: 20px;
          i {
            color: #fff;
            width: 9px;
            line-height: 16px;
          }
        }
        .el-tabs__nav {
          border: 0;
          height: 20px;
          .el-tabs__item {
            padding: 0 !important;
            width: 52px;
            text-align: center;
            border: 0;
            height: 20px;
            &:not(.is-active) {
              color: #fff;
            }
          }
        }
      }
      // 若年份数量小于4，则居中展示
      &.year-center {
        .el-tabs__header {
          .el-tabs__nav {
            float: none;
          }
        }
      }
    }
    .el-input__inner {
      height: 6.4vw;
      text-align: center;
      font-size: 3.7vw;
      font-family: FZYOUHS_510M--GB1-0, FZYOUHS_510M--GB1;
      color: #6b2d00;
      line-height: 6.4vw;
      padding: 0 4vw;
    }
    .el-input__icon {
      line-height: 6.4vw;
      color: #6b2d00 !important;
      transform: rotateZ(180deg) scale(0.5) !important;
      position: absolute;
      right: 8vw;
    }
  }
  .contentWrap {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    margin: 0 24px;
    .book {
      width: 114px;
      height: 208px;
      margin-top: 15px;
      cursor: pointer;
      &:nth-child(2n + 1) {
        margin-right: 24px;
      }
      .cover {
        height: 160px;
        background: no-repeat center/100%;
        margin: 3px;
        margin-bottom: 5px;
        img {
          height: 154px;
          width: 108px;
        }
      }
      &.active {
        .cover {
          border: 3px solid #df5813;
          margin: 0;
          margin-bottom: 8px;
        }
      }
      .name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #fff;
        line-height: 20px;
        text-align: center;
        text-overflow: ellipsis;
        // white-space: nowrap; // 单行文本溢出处理
        overflow: hidden;
        // 多行文本溢出处理，兼容性不好
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
    }
    &.list {
      align-content: flex-start;
      .book {
        width: 100%;
        height: 20px;
        &:nth-child(2n + 1) {
          margin-right: 0;
        }
        &.active {
          .name {
            color: #df5813;
          }
        }
      }
    }
    // 针对移动端单独样式
    &.mobile {
      margin: 0 14.4vw;
      .book {
        width: 30.4vw;
        height: 55.5vw;
        margin-top: 4vw;
        &:nth-child(2n + 1) {
          margin-right: 10.4vw;
        }
        .cover {
          height: 42.7vw;
          margin: 0.8vw;
          margin-bottom: 1.3vw;
          img {
            height: 41.1vw;
            width: 28.8vw;
          }
        }
        &.active {
          .cover {
            border-width: 0.8vw;
            margin: 0;
            margin-bottom: 2.1vw;
          }
        }
        .name {
          font-size: 3.7vw;
          line-height: 5.3vw;
        }
      }
      &.list {
        .book {
          width: 100%;
          height: 5.3vw;
          &:nth-child(2n + 1) {
            margin-right: 0;
          }
        }
      }
    }
  }
}
.quickSwitchSelect {
  .el-select-dropdown__item {
    text-align: center;
  }
}
</style>
